enum QuestionType {
  MultipleChoice = 'multiple-choice',
  TextEntry = 'text-entry',
  TextareaEntry = 'textarea-entry',
  MultipleSelection = 'multiple-selection',
  MultipleSelectionTable = 'multiple-selection-table',
  MultipleChoiceTable = 'multiple-choice-table',
  Unsure = 'unsure',
  Unsure1A3 = 'unsure1A3',
  Complete = 'complete',
  Rank = 'rank',
  Slider = 'slider',
  Info = 'info',
}

export default QuestionType;
